module.exports = __webpack_public_path__ + "6f76cde943150b133e16366923893790.svg";